<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-ident">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              add_a_photo
            </v-icon>
            <h3 class="title ml-2">
              Create ident case
              <span v-if="currentUser">
                for {{ currentUser.first_name }} {{ currentUser.last_name }}
              </span>
            </h3>
            <v-spacer />
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />
          <v-card-title class="toolbar grey lighten-5 secondary--text">
            <ident-user-search
              :on-user-select="onUserSelect"
              :is-loading-user-detail="isLoadingUserDetail"
              :current-user="currentUser"
            />
          </v-card-title>

          <v-card-text>
            <v-container
              class="pa-0"
            >
              <v-layout flex>
                <!-- PROVIDER -->
                <v-layout
                  class="form-group inline"
                  flex
                >
                  <h6 class="subheading">
                    Provider
                  </h6>

                  <v-flex>
                    <v-radio-group
                      v-model="provider"
                      row
                      :disabled="!currentUser"
                      @change="providerUpdate"
                    >
                      <v-radio
                        v-for="provider in identProviders"
                        :key="provider.id"
                        :value="provider.name"
                        :label="provider.name"
                        color="primary"
                      />
                    </v-radio-group>
                    <v-spacer />
                  </v-flex>
                </v-layout>
                <!-- BRAND -->
                <v-layout
                  v-if="!isExporoProvider"
                  class="form-group inline"
                  flex
                >
                  <h6 class="subheading">
                    Domain (brand)
                  </h6>

                  <v-flex>
                    <v-radio-group
                      v-model="domain"
                      row
                      :disabled="!currentUser"
                    >
                      <v-radio
                        v-for="domain in identDomains"
                        :key="domain.value"
                        :value="domain.value"
                        :label="domain.name"
                        color="primary"
                      />
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-layout>

              <!-- USER DETAILS -->
              <v-layout
                v-if="provider"
                wrap
                class="form-group"
              >
                <h6 class="subheading">
                  User details
                </h6>

                <v-flex
                  v-if="!currentUser"
                  xs12
                  class="error--text"
                >
                  There is no user selected.
                </v-flex>

                <v-layout
                  v-else
                  wrap
                >
                  <!-- START POST IDENT / IDNOW FORMS -->
                  <external-ident-form-fields
                    v-if="!isExporoProvider"
                    ref="formFields"
                    :current-user="currentUser"
                    :provider="provider"
                    :on-submit="createExternalIdent"
                  />
                  <!-- END POST IDENT / IDNOW FORMS -->
                  <exporo-ident-form-fields
                    v-else
                    ref="formFields"
                    :current-user="currentUser"
                    :on-submit="createExporoIdent"
                  />
                </v-layout>
              </v-layout>
            </v-container>
            <v-alert
              v-if="error"
              :value="error"
              type="error"
              color="error"
            >
              {{ error }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="primary"
                  @click="submitFormFields"
                  v-on="on"
                >
                  <span>Create
                    {{ provider ? `${provider} ` : "" }}
                    ident case</span>
                </v-btn>
              </template>
              <span>Validate and submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { identProviders } from '@/enum/ident/IdentEnum';
import IdentUserSearch from '@/components/ident/shared/IdentUserSearch';
import ExporoIdentFormFields from '@/components/ident/dialog/create/ExporoIdentFormFields';
import ExternalIdentFormFields from '@/components/ident/dialog/create/ExternalIdentFormFields';

export default {
  name: 'CreateIdentDialog',
  components: {
    IdentUserSearch,
    ExporoIdentFormFields,
    ExternalIdentFormFields,
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
    currentUser: {
      type: Object,
      default: null,
    },
    // ident-user-search component
    isLoadingUserDetail: {
      type: Boolean,
      required: true,
    },
    onUserSelect: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    isLoading: false,
    isLoadingUsers: false,
    pickerBirthDateOpen: false,
    pickerDocDateOpen: false,
    error: null,
    userResults: [],
    provider: identProviders.IDNOW,
    domain: 'exporo',
    identDomains: [
      { name: 'Exporo', value: 'exporo' },
      { name: 'Propvest', value: 'propvest' },
    ],
  }),

  computed: {
    isExporoProvider() {
      return this.provider === identProviders.EXPORO;
    },
    identProviders() {
      return this.$store.state.identStore.providers;
    },
  },

  methods: {
    providerUpdate(value) {
      this.provider = value;
    },
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    submitFormFields() {
      this.$refs.formFields.submit();
    },
    createExternalIdent(postData = null) {
      if (postData) {
        this.isLoading = true;
        if (postData.provider !== identProviders.EXPORO) {
          postData.domain = this.domain;
          postData.email = this.currentUser.email;
        }

        this.$store
          .dispatch('createExternalIdent', postData)
          .then((result) => {
            if (result) {
              this.$store.dispatch('fetchIdents', { userId: postData.userId });

              this.onToggleOpen();
            } else {
              throw new Error(`Unable to create ${postData.provider} Ident case.
              Make sure the user has no success ident cases or ${postData.provider} ident cases already created.`);
            }
          })
          .catch((err) => {
            this.error = err.response ? err.response.data.error : err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    createExporoIdent(postData = null) {
      if (postData) {
        this.isLoading = true;
        this.$store
          .dispatch('createExporoIdent', postData)
          .then(({ data }) => {
            if (data) {
              this.$store.dispatch('fetchIdents', { userId: postData.userId });
              this.onToggleOpen();
            } else {
              throw new Error(`Unable to create ${postData.provider} Ident case.
              Make sure the user has no success ident cases or ${postData.provider} ident cases already created.`);
            }
          })
          .catch((err) => {
            this.error = err;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" >
.create-ident {
  .v-card__title {
    padding: 24px;
  }
  .v-card__text {
    max-height: 65vh;
    overflow: auto;
    padding-top: 32px;
  }
  .v-card__actions {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .radio-label {
    position: absolute;
    font-size: 16px;
    text-align: left;
    max-width: 133%;
    height: 20px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.54);
    -webkit-transform: translateY(-18px) scale(0.75);
    transform: translateY(0px) translateX(-6px) scale(0.75);
  }
  .subheading {
    padding: 8px;
    background: white;
    color: rgba(0, 0, 0, 0.54);
    top: -20px;
    left: 8px;
    position: absolute;
    display: flex;
    align-items: center;
  }
  .form-group {
    padding: 16px;
    margin: 0 0 24px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    position: relative;
    &.inline {
      display: inline-flex;
      width: 50%;
    }
  }
  .container.grid-list-md .layout:not(:only-child) {
    margin: 0 0 24px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ident/dialog/create/CreateIdentDialog.vue